import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickBeautyDepartment = () => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_BEAUTY_DEPARTMENT',
      analytics: { TYPE: 'BANNER' },
    });
  }, []);
};
